var map = {
	"./2025-test1/problems": [
		7392
	],
	"./private-problems/problems": [
		4672,
		672
	],
	"./problems/problems": [
		7392
	],
	"./public-problems/problems": [
		6219,
		219
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2739;
module.exports = webpackAsyncContext;